<template>
  <div class="content">
    <div class="left-content" ref="alarmRap">
      <div class="chart-wrap" v-if="typeIndex == 1">
        <Alarm-chart-for-property
          v-if="actionData && eventLevel"
          :alarmWrap_h="alarmWrap_h"
          :typeIndex="typeIndex"
          :typeData="actionData"
          :levelData="eventLevel"
        ></Alarm-chart-for-property>
      </div>
      <div class="chart-wrap" v-if="typeIndex == 2">
        <Alarm-chart-for-companyLessee
          v-if="actionData && eventLevel"
          :alarmWrap_h="alarmWrap_h"
          :typeIndex="typeIndex"
          :typeData="actionData"
          :levelData="eventLevel"
        ></Alarm-chart-for-companyLessee>
      </div>
      <div class="chart-wrap" v-if="typeIndex == 3">
        <Alarm-chart-for-personalLessee
          v-if="actionData && eventLevel"
          :alarmWrap_h="alarmWrap_h"
          :typeIndex="typeIndex"
          :typeData="actionData"
          :levelData="eventLevel"
        ></Alarm-chart-for-personalLessee>
      </div>
      <!-- <tree-components
        ref="popertyTreeComponents"
        :treeList="popertyTreeList"
        :defaultProps="defaultProps"
        :activeNode="popertyActiveNode"
        @handleNodeChange="handlePopertyNodeChange"
        @handleGetTreeList="handleGetTreeList"
      >
      </tree-components> -->
    </div>
    <!-- <div class="left-content">
      <tree-components
        ref="treeComponents"
        :treeList="treeList"
        :defaultProps="defaultProps"
        :activeNode="activeNode"
        @handleNodeChange="handleNodeChange"
        @handleGetTreeList="handleGetTreeList"
      >
      </tree-components>
    </div> -->
    <div class="right-content">
      <!-- <company-info ref="companyInfo" :companyName="companyName" :tel="tel">
      </company-info> -->
      <alarm
        @eventLevel="getEventLevel"
        @actionData="getActionData"
        :typeIndex="typeIndex"
        :activeNode="activeNode"
      ></alarm>
    </div>
  </div>
</template>

<script>
import Socket from "@/utils/websocket";
import treeComponents from "./treeComponents.vue";
import companyInfo from "./companyInfo.vue";
import alarm from "./alarm.vue";
// import AlarmChart from "./AlarmChart.vue";
import AlarmChartForProperty from "@/components/page/alarm/AlarmChartForProperty.vue";
import AlarmChartForCompanyLessee from "@/components/page/alarm/AlarmChartForCompanyLessee.vue";
import AlarmChartForPersonalLessee from "@/components/page/alarm/AlarmChartForPersonalLessee.vue";
export default {
  name: "propertyService",
  components: {
    AlarmChartForProperty,
    AlarmChartForCompanyLessee,
    AlarmChartForPersonalLessee,
    // treeComponents,
    alarm
  },
  props: {
    typeIndex: String
  },
  data() {
    return {
      alarmWrap_h: 0,
      type: {
        1: "getRentalAreaTrusteeshipContractForProperty",
        2: "getLeaseContractForCompanyLessee",
        3: "getLeaseContractForPersonalLessee"
      },
      actionData: null,
      areaList: [],
      activeName: "card",
      popertyActiveNode: "",
      activeNode: "",
      treeList: [],
      popertyTreeList: [],

      companyName: "",
      tel: "",
      dataList: [],
      tableData: [],
      webSocket: null,
      webSocketOptions: {
        ip: "",
        key: "",
        path: "",
        port: ""
      },
      eventLevel: null,
      switchList: []
    };
  },
  created() {
    // Promise.all([
    //   this.handleGetCompanyInfo(),
    //   this.handleGetTreeList()
    // ]).then(() => {});
  },
  mounted() {
    this.alarmWrap_h = this.$refs.alarmRap.offsetHeight;
  },
  methods: {
    getActionData(res) {
      this.actionData = res;
    },
    getEventLevel(res) {
      this.eventLevel = res;
    },
    handleGetCompanyInfo() {
      this.$api.company.getCompanyInfo().then(res => {
        if (res.success) {
          this.companyName = res.data.name;
          this.tel = res.data.contactPhoneNumber;
        }
      });
    },
    handleDuplicates(arr) {
      var result = [];
      var obj = {};
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].id]) {
          result.push(arr[i]);
          obj[arr[i].id] = true;
        }
      }
      return result;
    },
    resultDispose(res) {
      if (res.success) {
        let PropertyList = [];
        let PropertyObj = {};
        let areaList = [];
        res.data.forEach(item => {
          PropertyObj = {};
          PropertyObj["name"] =
            item[
              this.typeIndex == 2
                ? "lesseeTransactorNickname"
                : "proprietorCompanyName"
            ];
          PropertyObj["id"] =
            item[this.typeIndex == 2 ? "lesseeId" : "proprietorCompanyId"];
          PropertyList.push(PropertyObj);
          areaList = areaList.concat(item.areas);
          this.areaList = areaList.concat(item.areas);
        });
        // areaList = areaList.filter(c => c.companyId == PropertyList[0].id);
        let result = this.handleDuplicates(areaList);
        this.popertyTreeList = this.handleDuplicates(PropertyList);
        console.log(this.popertyTreeList);
        this.popertyActiveNode = PropertyList[0].id;
        this.$nextTick(() => {
          this.$refs["popertyTreeComponents"].handleSetCurrentKey(
            PropertyList[0].id
          );
        });
        let areaIdList = result.map(item => {
          return item.id;
        });
        this.getSubRentalAreas(areaIdList);
      }
    },
    handleGetTreeList() {
      this.treeList = [];
      this[this.type[this.typeIndex]]();
    },
    getSubRentalAreas(areaIdList) {
      this.$api.rentalArea.getSubRentalAreas(areaIdList, 1).then(res => {
        if (res.success) {
          this.handleTreeList(res.data);
          this.dataList = [res.data[0]];
          this.activeNode = res.data[0].id;
          this.$nextTick(() => {
            this.$refs["treeComponents"].handleSetCurrentKey(res.data[0].id);
          });
        }
      });
    },
    handleTreeList(list) {
      let allListId = list.map(item => {
        return item.id;
      });
      // 找不到parentId的，pid为0
      list.forEach(item => {
        item.pid = item.parentId;
        if (allListId.indexOf(item.parentId) === -1) {
          item.pid = 0;
        }
      });
      this.treeList = this.handleRecursion(list, 0);
    },
    handleRecursion(list, pid) {
      let arr = [];
      list.forEach(item => {
        if (item.pid === pid) {
          item.children = this.handleRecursion(list, item.id);
          arr.push(item);
        }
      });
      // console.log(arr)
      return arr;
    },
    handleNodeChange(data) {
      this.activeNode = data.id;
      this.dataList = this.handleGetAllLeaf([data]);
      this.handleGetRoomSwitches();
    },
    handlePopertyNodeChange(data) {
      // debugger
      // let areaList = this.areaList.filter(c => c.companyId == data.id);
      let result = this.handleDuplicates(this.areaList);
      let areaIdList = result.map(item => {
        return item.id;
      });
      this.getSubRentalAreas(areaIdList);
    },
    handleGetAllLeaf(data) {
      let result = [];
      const getLeaf = nodeList => {
        nodeList.forEach(item => {
          if (item.children.length === 0) {
            result.push(item);
          } else {
            getLeaf(item.children);
          }
        });
      };
      getLeaf(data);
      return result;
    },
    handleGetRoomSwitches() {
      this.switchList = [];
      let requestList = this.dataList.map(item => {
        return this.$api.rentalArea.getRentalAreaSwitches(item.id);
      });
      Promise.all(requestList).then(res => {
        if (res[0].success) {
          this.dataList = this.dataList.map((item, index) => {
            return {
              ...item,
              switchList: res[index].data
            };
          });
          this.handleGetWebsocketUrl();
        }
      });
    },

    handleWebSocketInit() {
      if (this.webSocket !== null) {
        this.webSocket.close();
      }
      let result = "";
      this.webSocket = new Socket({
        url:
          window.baseConfig.wsAgreement +
          "://" +
          this.webSocketOptions.ip +
          ":" +
          this.webSocketOptions.port +
          "/" +
          this.webSocketOptions.path
      });
      this.webSocket.onopen(() => {
        console.log(this.webSocketOptions.key);
        this.webSocket.send({
          methodCode: "101",
          key: this.webSocketOptions.key
        });
      });
      this.webSocket.onmessage(res => {
        console.log(JSON.parse(res));
        result = JSON.parse(res);
        this.handdleWebSocketOnmessage(result);
      });
    },
    handdleWebSocketOnmessage(res) {
      if (res.methodCode === "102") {
        let message = this.dataList.map(item => {
          return {
            id: item.switchList[0].id,
            points: [
              { code: 201, number: 0 },
              { code: 202, number: 0 },
              { code: 203, number: 0 },
              { code: 207, number: 0 },
              { code: 208, number: 0 },
              { code: 209, number: 0 },
              { code: 211, number: 0 },
              { code: 215, number: 0 },
              { code: 223, number: 0 }
            ]
          };
        });
        let switchInfo = [];
        this.dataList.forEach(data => {
          data.switchList.forEach(item => {
            switchInfo.push({
              id: item.id,
              points: [{ code: 601, number: 0 }]
            });
          });
        });
        let requsetInfo = [...switchInfo, ...message];
        console.log(requsetInfo);
        this.webSocket.send({
          methodCode: "103",
          measures: requsetInfo
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  .left-content {
    // width: 280px;
    height: 100%;
    // border: 1px solid;
    box-sizing: border-box;
  }
  .right-content {
    margin-left: 16px;
    width: calc(100% - 296px);
    height: 100%;
    display: flex;
    flex-direction: column;
    // border: 1px solid;
    box-sizing: border-box;
  }
}

.el-tabs {
  height: 100%;
  ::v-deep .el-tabs__content {
    height: calc(100% - 60px);
  }
  ::v-deep .el-tabs__nav {
    float: right;
  }
  .el-tab-pane {
    height: 100%;
  }
}
.chart-wrap {
  width: 360px;
  // height: 100%;
  margin-right: 13px;
  // width: 490px;height: 100%;margin-right: 13px;
}
</style>
